import * as React from 'react';

import moment from 'moment';

import {checkMultiDay} from '../../../../../../../core/date-time/activity-time-helpers';

import {FormattedTimestamp} from '../../timestamp/formatted-timestamp';
import {Body} from '../../typography/body';

type Props = {
    startTime: number;
    endTime: number;
    isAllDay: boolean;
    isOverdue: boolean;
};

export function ActivityDateAndTime(props: Props) {
    const isMultiDay = checkMultiDay(props.startTime, props.endTime);

    const isCurrentYear = moment.unix(props.startTime).isSame(moment(), 'year');
    const format = isCurrentYear
        ? FormattedTimestamp.formats.longDayMonth
        : FormattedTimestamp.formats.longMonthDayWithYear;

    return (
        <Body color={props.isOverdue ? 'error' : 'medium'} size='small' truncate={{type: 'block'}}>
            {isMultiDay && (
                <>
                    <FormattedTimestamp
                        datetime={props.startTime}
                        format={format}
                        showDetailedPopover={true}
                    />{' '}
                    -{' '}
                    <FormattedTimestamp
                        datetime={props.endTime}
                        format={format}
                        showDetailedPopover={true}
                    />
                </>
            )}
            {props.isAllDay && !isMultiDay && (
                <FormattedTimestamp
                    datetime={props.startTime}
                    format={format}
                    showDetailedPopover={true}
                />
            )}
            {!props.isAllDay && !isMultiDay && (
                <>
                    <FormattedTimestamp
                        datetime={props.startTime}
                        format={format}
                        isInline={true}
                    />
                    {' • '}
                    <FormattedTimestamp
                        datetime={props.startTime}
                        format={FormattedTimestamp.formats.time}
                        isInline={true}
                    />{' '}
                    -{' '}
                    <FormattedTimestamp
                        datetime={props.endTime}
                        format={FormattedTimestamp.formats.time}
                        isInline={true}
                    />
                </>
            )}
        </Body>
    );
}
